/* Vegardians – Taster Bundle Popup (global, delegiert)
   Funktioniert auf Produktseiten UND in der Schnellansicht (Quick-Buy Drawer/Popover),
   wo per AJAX injizierte Inline-Scripts nie ausgefuehrt werden.
   Ersetzt die frueheren Inline-Scripts in snippets/product-form.liquid und
   snippets/taster-bundle-popup.liquid (dort entfernt, sonst Doppel-Events). */
(function () {
  'use strict';

  function findPopup(from) {
    var scope = from && from.closest ? from.closest('.product-form--taster-bundle') : null;
    return (scope && scope.querySelector('.taster-bundle-popup')) ||
      document.getElementById('taster-bundle-popup');
  }

  function closePopup(popup) {
    if (popup) popup.classList.remove('active');
    document.body.classList.remove('taster-popup-open');
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest ? e.target.closest('#open-taster-bundle-popup') : null;
    if (openBtn) {
      e.preventDefault();
      var popup = findPopup(openBtn);
      if (popup) {
        popup.classList.add('active');
        document.body.classList.add('taster-popup-open');
      }
      return;
    }

    var closeBtn = e.target.closest ? e.target.closest('#close-taster-bundle-popup, .taster-bundle-popup__close') : null;
    if (closeBtn) {
      closePopup(closeBtn.closest('.taster-bundle-popup'));
      return;
    }

    /* Klick auf den Overlay-Hintergrund schliesst */
    if (e.target.classList && e.target.classList.contains('taster-bundle-popup')) {
      closePopup(e.target);
      return;
    }

    /* Mengen-Buttons im Popup */
    var qtyBtn = e.target.closest ? e.target.closest('.taster-bundle-popup .qty-btn') : null;
    if (qtyBtn && !qtyBtn.disabled) {
      e.preventDefault();
      var ctrl = qtyBtn.closest('.quantity-control');
      var input = ctrl && ctrl.querySelector('input[type="number"]');
      if (!input || input.disabled) return;
      input.removeAttribute('readonly');
      var min = parseInt(input.min || '0', 10);
      var max = parseInt(input.max || '100', 10);
      var val = parseInt(input.value, 10) || 0;
      val += qtyBtn.classList.contains('plus') ? 1 : -1;
      input.value = Math.max(min, Math.min(max, val));
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'taster-bundle-popup-form') return;
    e.preventDefault();

    var feedback = form.querySelector('.bundle-feedback');
    function showError(msg) {
      if (!feedback) return;
      feedback.textContent = msg;
      feedback.classList.add('error');
      feedback.style.display = 'block';
    }
    if (feedback) {
      feedback.style.display = 'none';
      feedback.classList.remove('error');
      feedback.textContent = '';
    }

    var selections = [];
    form.querySelectorAll('input[type="number"][name^="flavor_"]').forEach(function (input) {
      var qty = parseInt(input.value, 10) || 0;
      var id = parseInt(input.name.replace('flavor_', ''), 10);
      if (qty > 0 && id) selections.push({ id: id, quantity: qty });
    });

    if (selections.length === 0) {
      showError('Bitte wähle mindestens eine Sorte aus.');
      return;
    }

    var i = 0;
    function addNext() {
      if (i >= selections.length) {
        closePopup(form.closest('.taster-bundle-popup'));
        /* offene Schnellansicht schliessen, falls vorhanden */
        var openDrawer = document.querySelector('.drawer--quick-buy[open], .popover--quick-buy[open]');
        if (openDrawer) openDrawer.removeAttribute('open');
        var miniCart = document.getElementById('mini-cart');
        if (miniCart) {
          if (typeof miniCart.refresh === 'function') miniCart.refresh();
          miniCart.setAttribute('open', '');
          /* Warenkorb-Zaehler aktualisieren, falls Theme das Event kennt */
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } else {
          window.location.href = '/cart';
        }
        return;
      }
      var item = selections[i];
      i += 1;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(item)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Fehler beim Hinzufügen zum Warenkorb.');
          return r.json();
        })
        .then(addNext)
        .catch(function (err) {
          showError((err && err.message) || 'Fehler beim Hinzufügen zum Warenkorb.');
        });
    }
    addNext();
  });
})();
